import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Region, RegionResponse } from 'application/types/Region';
import api from 'application/utilities/axiosIntance';

interface RegionState {
  region: string;
  regionList: Region[];
  isLoading: boolean;
}

const initialState: RegionState = {
  region: sessionStorage.getItem("savedRegion") || "",
  regionList: [],
  isLoading: true,
};

export const fetchRegions = createAsyncThunk(
  'region/fetchRegions',

  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get<RegionResponse>("/Login/GetPortalRegions");
      if (data.isSuccess) {
        return data.result;
      }
      return [];
    }
    catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    setRegion: (state, action: PayloadAction<string>) => {
      state.region = action.payload;
      sessionStorage.setItem("savedRegion", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.regionList = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRegions.rejected, (state) => {
        state.isLoading = false;
      })
  }
});

export const { setRegion } = regionSlice.actions;
export default regionSlice.reducer;

